import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

// Guard que valida permiso de acceso a la página de facturación masiva. 23/07/2026
@Injectable()
export class FacturacionMasivaGuard implements CanActivate {
  options: any[] = [];

  constructor(public router: Router) {}

  canActivate() {
    this.options = JSON.parse(localStorage.getItem('dataacc'));
    if (this.options.includes(btoa('/facturacionmasiva'))) {
      return true;
    } else {
      this.router.navigate(['/dashboard']);
      return false;
    }
  }
}
